export default __webpack_public_path__ + "static/media/img-2.78f380e8.png";